export const TOGGLE_LOADING_SUGGESTIONS = 'TOGGLE_LOADING_SUGGESTIONS'

export const ADD_SUGGESTIONS = 'ADD_SUGGESTIONS'
export const SET_SUGGESTIONS = 'SET_SUGGESTIONS'
export const ADD_APPROVED_SUGGESTION = 'ADD_APPROVED_SUGGESTION'
export const UPDATE_SUGGESTION = 'UPDATE_SUGGESTION'
export const UPDATE_SUGGESTION_STATUS = 'UPDATE_SUGGESTION_STATUS'
// NOTE: Use this for quick prototyping. Don't overuse.
export const UPDATE_SUGGESTION_MODULE = 'UPDATE_SUGGESTION_MODULE'

export const SET_USERS_LAST_SUGGESTION = 'SET_USERS_LAST_SUGGESTION'

export const SET_EMOTE_REACTION = 'SET_EMOTE_REACTION'
export const SET_LIST_FILTERS = 'SET_LIST_FILTERS'
export const SET_PAGINATION_INFO = 'SET_PAGINATION_INFO'
export const SET_VOTE_TYPE = 'SET_VOTE_TYPE'

export const SET_REPLY_TO_SUGGESTION = 'SET_REPLY_TO_SUGGESTION'

export const UPDATE_SUGGESTION_BOUNTY = 'UPDATE_SUGGESTION_BOUNTY'
export const SET_TRANSACTING_BOUNTY_STATE = 'SET_TRANSACTING_BOUNTY_STATE'
export const SET_COMPLETED_TRANSACTION = 'SET_COMPLETED_TRANSACTION'

export const SET_NOW_TIME = 'SET_NOW_TIME'

export const DEMO_LINK_PREVIEW = 'DEMO_LINK_PREVIEW'
